export const pageType = {
  'quick-order': 'quick order',
  'document-search': 'document search',
  cart: 'shopping cart',
  checkout: 'checkout',
  product: 'product detail',
  'order-history': 'account order',
  'order-detail': 'account order',
  favorites: 'favorites',
  freight: 'freight',
  'search/search-result': 'search results',
  'search/search-result/structure': 'product tool',
  'contact-us': 'contact us',
  'search/structure': 'product tool',
  'custom-bulk': 'custom bulk',
  'search/category': 'product category',
  'payment-history': 'account order',
  'request-form': 'request form',
  welcome: 'welcome',
};
export const pageName = {
  'quick-order': 'quick order',
  'document-search': 'document search',
  cart: 'shopping cart',
  checkout: 'checkout::store:v2:checkout:orderEntry',
  product: 'products:detail:',
  'order-history': 'store:orders:history',
  'order-detail': 'account order:account order detail',
  favorites: 'favorites',
  freight: 'freight',
  'search/search-result': 'search results:product',
  'search/search-result/structure': 'product tool:chemical structure search:search result',
  'contact-us': 'contact us',
  'search/structure': 'product tool:chemical structure search',
  'custom-bulk': 'custom bulk',
  'search/category': 'product category',
  'payment-history': 'account order:payment history',
  'request-form': 'request form',
  welcome: 'welcome',
};
export const pdpInteractions = {
  element_search: 'Element Search',
  structure_search: 'Structure Search',
  sds_up: 'SDS(up)',
  coa: 'COA',
  specification_sheet: 'Specification Sheet',
  request_a_certificate: 'Request a Certificate',
  sds_down: 'SDS(down)',
  request_quote: 'Request bulk or custom quote',
};
